import './style.css'
import '../../fonts/fonts.css'
// eslint-disable-next-line import/no-webpack-loader-syntax
import '!style!css!../../styles/index.css'
import React, { Component } from 'react'
import Navigation from '../navigation'
import Container from '../container'
import Cart from '../../containers/cart'
import { connect } from 'react-redux'
import { getCurrency } from '../../api/diamond'
import Modals from '../../containers/modals'
import * as actions from '../../actions/settings'

const mapStateToProps = (state, ownProps) => {
  return {
    modalOpen: state.settings.preferencesModalOpen
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setExchange: (val) => {
      dispatch(actions.setExchangeRate(val))
    },
    hidePreferences: () => {
      dispatch(actions.hidePreferences())
    }
  }
}

class MainLayout extends Component {
  componentDidMount (item) {
    getCurrency()
      .then((res) => {
        this.props.setExchange(res.data.exchange_rate)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  render () {
    return (
      <div>
        <Modals />
        <Navigation />
        <Container>
          <Cart />
          {this.props.children}
        </Container>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout)



// WEBPACK FOOTER //
// ./src/components/layout-main/index.js